<template>
  <div class="row">
    <div class="col-xs-12">
      <flCabecalhoForm
        cls="print-titulo-form-20"
        :texto="_traducao('global','trecho').toUpperCase()"
      />

      <div v-for="(item, index) in form.trecho" :key="index">
        <div class="col-xs-12 text-center">
          <i
            class="fa fa-chevron-down"
            style="color: #2196F3; font-size: 20px"
            v-show="index"
            aria-hidden="true"
          ></i>
        </div>

        <h4
          style="margin-bottom: -6px;"
          :style="{'margin-top' : index == 0 ? '0px' : '10px' }"
        >{{_traducao('global', 'trecho').toUpperCase()}} {{index + 1}}</h4>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="text-center">
              <span
                style="margin-bottom: 0px;"
              >{{_traducao('menuSolicitaApoio', 'partida').toUpperCase()}}</span>
            </div>

            <div class="trecho-borda" style="min-height: 330px">
              <div class="row">
                <div
                  class="col-xs-12 col-md-12 form-group"
                  :class="{'has-error' : item.erro_pais_partida != ''}"
                >
                  <label>* País:</label>
                  <v-select
                    v-show="listaPaises.length"
                    :options="listaPaises"
                    v-model="item.pais_partida"
                    label="descricao"
                    class="form-control input-sm"
                    @input="carregaEstados(item, index, 'P')"
                  ></v-select>
                  <flCarregando v-show="!listaPaises.length"></flCarregando>
                  <p
                    class="help-block"
                    v-if=" item.erro_pais_partida != ''"
                  >{{item.erro_pais_partida}}</p>
                </div>

                <!-- ESTADO -->
                <div
                  class="col-xs-12 col-md-6 form-group"
                  :class="{'has-error' : item.erro_estado_partida != ''}"
                >
                  <label>
                    <span>*</span>
                    {{_traducao('global', 'estado')}}:
                  </label>
                  <v-select
                    :options="item.lista_estados_partida"
                    label="province"
                    class="form-control input-sm"
                    v-model="item.estado_partida"
                    @input="carregaCidades(item, index, 'P')"
                    v-if="!item.loadEstadoPartida"
                  ></v-select>
                  <p
                    class="help-block"
                    v-show="item.erro_estado_partida != ''"
                  >{{item.erro_estado_partida}}</p>
                  <flCarregando v-show="item.loadEstadoPartida"></flCarregando>
                </div>

                <!-- CIDADE -->
                <div
                  class="col-xs-12 col-md-6 form-group"
                  :class="{'has-error' : item.erro_cidade_partida != ''}"
                >
                  <label>
                    <span>*</span>
                    {{_traducao('global', 'cidade')}}:
                  </label>
                  <v-select
                    :options="item.lista_cidades_partida"
                    label="cidade"
                    class="form-control input-sm"
                    v-model="item.cidade_partida"
                    @input="carregaAeroporto(item, index, 'P')"
                    v-if="!item.loadCidadePartida"
                  ></v-select>
                  <p
                    class="help-block"
                    v-show="item.erro_cidade_partida != ''"
                  >{{item.erro_cidade_partida}}</p>
                  <flCarregando v-show="item.loadCidadePartida"></flCarregando>
                </div>
              </div>

              <div class="row">
                <!-- DESIGNATIVO -->
                <div
                  class="col-xs-12 form-group"
                  :class="{'has-error': item.erro_designativo_partida != ''}"
                >
                  <label>* {{_traducao('global', 'aeroporto')}}:</label>
                  <v-select
                    :options="item.rotaer_partida"
                    v-model="item.designativo_partida"
                    class="form-control input-sm"
                    label="_label"
                    @input="calculaFusoOrigem(index, form.trecho[index], 'P');
                                            verificaAeroporto(index, form.trecho[index])"
                    v-if="!item.loadAeroportoPartida"
                  ></v-select>
                  <flCarregando v-show="item.loadAeroportoPartida"></flCarregando>
                  <p
                    class="help-block"
                    v-if="item.erro_designativo_partida != ''"
                  >{{ item.erro_designativo_partida }}</p>
                </div>
              </div>

              <div class="row">
                <!-- LATITUDE -->
                <div class="col-xs-6 col-lg-6 form-group">
                  <label>{{_traducao('global', 'latitude')}}:</label>
                  <input
                    type="text"
                    v-model="item.lat_partida"
                    v-mask="'S00º00\'00'"
                    placeholder="DGGºMM'SS"
                    @blur="validaTamanhoTrecho(index, 'lat_partida', 9)"
                    class="form-control input-sm"
                  />
                </div>

                <!-- LONGITUDE -->
                <div class="col-xs-6 col-lg-6 form-group">
                  <label>{{_traducao('global', 'longitude')}}:</label>
                  <input
                    type="text"
                    v-model="item.lng_partida"
                    v-mask="'S000º00\'00'"
                    placeholder="DGGGºMM'SS"
                    @blur="validaTamanhoTrecho(index, 'lng_partida', 10)"
                    class="form-control input-sm"
                  />
                </div>

                <!-- DECOLAGEM -->
                <div
                  class="col-xs-12 col-md-5 form-group"
                  :class="{'has-error': item.erro_decolagem != ''}"
                >
                  <label>
                    <span class="no-print">*</span>
                    {{_traducao('global', 'decolagem')}} ({{_traducao('global', 'previsao')}}):
                  </label>
                  <flDateTime
                    @v-model="(val) => {item.decolagem_partida = val; calculaDataOrigemUTC(index)}"
                    :value="item.decolagem_partida"
                    :lang="_getLangDp"
                    :minDate="index > 0 ? form.trecho[index - 1].decolagem_partida : ''"
                    name="teste"
                    :format="'HH:mm'"
                  />
                  <p class="help-block" v-show="item.erro_decolagem != ''">{{item.erro_decolagem}}</p>
                </div>

                <!-- FUSO -->
                <div class="col-xs-12 col-md-2">
                  <label>Fuso:</label>
                  <input
                    type="text"
                    disabled
                    class="form-control input-sm"
                    v-model="item.fuso_partida"
                  />
                </div>

                <!-- DECOLAGEM -->
                <div class="col-xs-12 col-md-5">
                  <label>Decolagem (UTC):</label>
                  <input
                    type="text"
                    disabled
                    class="form-control input-sm"
                    v-model="item.decolagem_utc_partida"
                  />
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 10px">
              <div class="col-xs-12">
                <button
                  class="btn btn-sm btn-info pull-left"
                  type="button"
                  @click="clickTrechoAdd()"
                >
                  <i class="fa fa-plus fa-fw"></i>
                  {{_traducao('global', 'novoTrecho').toUpperCase()}}
                </button>

                <a
                  href="#"
                  class="trecho-excluir"
                  style="margin-left: 10px; width: 90px; height: 30px;"
                  v-show="index"
                  @click.prevent="clickTrechoRemover(index)"
                >
                  <i class="fa fa-trash-o fa-fw"></i>
                  {{_traducao('menuEscala', 'menuRemover')}}
                </a>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-md-6">
            <div
              v-if="_escondeMobile()"
              style="position: absolute; top: 165px; left: -8px; font-size: 20px"
            >
              <i class="fa fa-arrow-right" style="color: #2196F3" aria-hidden="true"></i>
            </div>

            <div class="text-center">
              <p
                style="margin-bottom: 0px;"
              >{{_traducao('menuSolicitaApoio', 'destino').toUpperCase()}}</p>
            </div>

            <div class="trecho-borda" style="min-height: 330px">
              <div class="row">
                <!-- PAÍS -->
                <div
                  class="col-xs-12 form-group"
                  :class="{'has-error': item.erro_pais_destino != ''}"
                >
                  <label>* País:</label>
                  <v-select
                    v-show="listaPaises.length"
                    class="form-control input-sm"
                    :options="listaPaises"
                    label="descricao"
                    v-model="item.pais_destino"
                    @input="carregaEstados(item, index, 'D')"
                  ></v-select>
                  <flCarregando v-show="!listaPaises.length"></flCarregando>
                  <p
                    class="help-block"
                    v-if="item.erro_pais_destino != ''"
                  >{{item.erro_pais_destino}}</p>
                </div>

                <!-- ESTADO -->
                <div
                  class="col-xs-12 col-md-6 form-group"
                  :class="{'has-error': item.erro_estado_destino != ''}"
                >
                  <label>
                    <span>*</span>
                    {{_traducao('global', 'estado')}}:
                  </label>
                  <v-select
                    :options="item.lista_estados_destino"
                    label="province"
                    class="form-control input-sm"
                    v-model="item.estado_destino"
                    @input="carregaCidades(item, index, 'D')"
                    v-if="!item.loadEstadoDestino"
                  ></v-select>
                  <p
                    class="help-block"
                    v-show="item.erro_estado_destino != ''"
                  >{{item.erro_estado_destino}}</p>
                  <flCarregando v-show="item.loadEstadoDestino"></flCarregando>
                </div>

                <!-- CIDADE -->
                <div
                  class="col-xs-12 col-md-6 form-group"
                  :class="{'has-error': item.erro_cidade_destino != ''}"
                >
                  <label>
                    <span>*</span>
                    {{_traducao('global', 'cidade')}}:
                  </label>
                  <v-select
                    :options="item.lista_cidades_destino"
                    label="cidade"
                    class="form-control input-sm"
                    v-model="item.cidade_destino"
                    @input="carregaAeroporto(item, index, 'D')"
                    v-if="!item.loadCidadeDestino"
                  ></v-select>
                  <p
                    class="help-block"
                    v-show="item.erro_cidade_destino != ''"
                  >{{item.erro_cidade_destino}}</p>
                  <flCarregando v-show="item.loadCidadeDestino"></flCarregando>
                </div>
              </div>

              <div class="row">
                <!-- DESIGNATIVO -->
                <div
                  class="col-xs-12 form-group"
                  :class="{'has-error' : item.erro_designativo_destino != ''}"
                >
                  <label>* {{_traducao('global', 'aeroporto')}}:</label>
                  <v-select
                    :options="item.rotaer_destino"
                    v-model="item.designativo_destino"
                    class="form-control input-sm"
                    label="_label"
                    @input="setaLatLong(index, form.trecho[index], 'D');
                                            verificaAeroporto(index, form.trecho[index])"
                    v-if="!item.loadAeroportoDestino"
                  ></v-select>
                  <flCarregando v-show="item.loadAeroportoDestino"></flCarregando>
                  <p
                    class="help-block"
                    v-if="item.erro_designativo_destino != ''"
                  >{{item.erro_designativo_destino }}</p>
                </div>
              </div>

              <div class="row">
                <!-- LATITUDE -->
                <div class="col-xs-6 col-md-6 col-lg-6 form-group">
                  <label>{{_traducao('global', 'latitude')}}:</label>
                  <input
                    type="text"
                    v-model="item.lat_destino"
                    v-mask="'S00º00\'00'"
                    @blur="validaTamanhoTrecho(index, 'lat_destino', 9)"
                    placeholder="DGGºMM'SS"
                    class="form-control input-sm"
                  />
                </div>

                <!-- LONGITUDE -->
                <div class="col-xs-6 col-md-6 col-lg-6 form-group">
                  <label>{{_traducao('global', 'longitude')}}:</label>
                  <input
                    type="text"
                    v-model="item.lng_destino"
                    v-mask="'S000º00\'00'"
                    @blur="validaTamanhoTrecho(index, 'lng_destino', 10)"
                    placeholder="DGGGºMM'SS"
                    class="form-control input-sm"
                  />
                </div>
              </div>

              <div class="row" v-if="item.tem_pouso_previsto">
                <div class="col-xs-6" :class="{'has-error' : item.erro_pouso_previsto != ''}">
                  <label>* Pouso Previsto:</label>
                  <flDateTime
                    @v-model="(val) => {item.pouso_previsto = val}"
                    :value="item.pouso_previsto"
                    :lang="_getLangDp"
                    :minDate="form.trecho[index].decolagem_partida"
                    name="teste"
                    :format="'HH:mm'"
                  />
                  <p
                    class="help-block"
                    v-if="item.erro_pouso_previsto != ''"
                  >{{item.erro_pouso_previsto}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trechoFactory from '../../../factories/solicitacao/editando'
export default {

	props: ['form', 'listaPaises'],

	methods: {

		clickTrechoRemover(index) {
			this.form.trecho.splice(index, 1)
		},

		clickTrechoAdd (){
			var index = this.form.trecho.length - 1
			this.form.trecho.push({
				id: 0,
				decolagem_partida: '',
				decolagem_partida_hora: '',

				designativo_partida: this.form.trecho[index].designativo_destino,
				designativo_destino: this.form.trecho[index].designativo_partida,

				icao_origem: this.form.trecho[index].icao_destino,
				icao_destino: this.form.trecho[index].icao_origem,

				rotaer_local_partida : '',
				rotaer_partida: this.form.trecho[index].rotaer_destino,

				rotaer_local_destino : '',
				rotaer_destino: this.form.trecho[index].rotaer_partida,

				descricao_partida: '',
				descricao_destino: '',

				loadCidadeDestino: false,
				loadEstadoDestino: false,
				loadAeroportoDestino: false,
				loadCidadePartida: false,
				loadEstadoPartida: false,
				loadAeroportoPartida: false,

				fuso_partida: '',
				fuso_destino: '',
				decolagem_utc_partida: '',

				lat_partida: '',
				lng_partida: '',

				lat_destino: '',
				lng_destino: '',

				id_estado_partida: this.form.trecho[index].estado_destino ? this.form.trecho[index].estado_destino.id : '' ,
				nome_estado_partida: '',
				estado_partida: this.form.trecho[index].estado_destino,

				id_estado_destino: this.form.trecho[index].estado_partida ? this.form.trecho[index].estado_partida.id : '',
				nome_estado_destino: '',
				estado_destino: this.form.trecho[index].estado_partida,

				id_cidade_partida: this.form.trecho[index].cidade_destino ? this.form.trecho[index].cidade_destino.id : '',
				nome_cidade_partida: '',
				cidade_partida: this.form.trecho[index].cidade_destino,

				id_cidade_destino: this.form.trecho[index].cidade_partida ? this.form.trecho[index].cidade_partida.id : '',
				nome_cidade_destino:'',
				cidade_destino: this.form.trecho[index].cidade_partida,

				lista_estados_partida: this.form.trecho[index].lista_estados_destino,
				lista_estados_destino: this.form.trecho[index].lista_estados_partida,

				lista_cidades_partida: this.form.trecho[index].lista_cidades_destino,
				lista_cidades_destino: this.form.trecho[index].lista_cidades_partida,

				id_pais_partida: this.form.trecho[index].pais_destino ? this.form.trecho[index].pais_destino.id : '',
				id_pais_destino: this.form.trecho[index].pais_partida ? this.form.trecho[index].pais_partida.id : '',
				pais_partida: this.form.trecho[index].pais_destino,
				pais_destino: this.form.trecho[index].pais_partida,

				tem_pouso_previsto: this.form.trecho[index].tem_pouso_previsto,
				pouso_previsto: this.form.trecho[index].pouso_previsto,

				erro_pouso_previsto: '',

				erro_estado_partida: '',
				erro_cidade_partida: '',

				erro_designativo_partida: '',
				erro_designativo_destino: '',

				erro_decolagem: '',
				erro_estado_destino: '',
				erro_cidade_destino: '',
				erro_descricao_destino: '',
				erro_pais_partida: '',
				erro_pais_destino: '',

				nao_tem_aerodromo: '',

				destinoEditando: trechoFactory.createEditandoObject(true),
				partidaEditando: trechoFactory.createEditandoObject(true),

			})
		},

		setaLatLong (index, item, tipo){
			if(tipo === 'P'){
				if(item.designativo_partida === 'ZZZZ'){
					this.form.trecho[index].lat_partida = ''
					this.form.trecho[index].lng_partida = ''
					this.form.trecho[index].rotaer_local_partida = ''
					this.form.trecho[index].descricao_partida = ''
				} else {
					if(item.designativo_partida !== ''){

						this.form.trecho[index].lat_partida = this._convertDMS(item.designativo_partida.latitude, item.designativo_partida.longitude).lat
						this.form.trecho[index].lng_partida = this._convertDMS(item.designativo_partida.latitude, item.designativo_partida.longitude).lng
					} else {
						this.form.trecho[index].lat_partida = ''
						this.form.trecho[index].lng_partida = ''
					}
				}
			}
			if(tipo === 'D'){
				if(item.designativo_destino === 'ZZZZ'){
					this.form.trecho[index].lat_destino = ''
					this.form.trecho[index].lng_destino = ''
					this.form.trecho[index].rotaer_local_destino = ''
					this.form.trecho[index].descricao_destino = ''
				} else {
					if(item.designativo_destino !== ''){
						this.form.trecho[index].lat_destino = this._convertDMS(item.designativo_destino.latitude, item.designativo_destino.longitude).lat
						this.form.trecho[index].lng_destino = this._convertDMS(item.designativo_destino.latitude, item.designativo_destino.longitude).lng
						this.calculaFusoDestino(index)
					} else {
						this.form.trecho[index].lat_destino = ''
						this.form.trecho[index].lng_destino = ''
					}
				}
			}
		},
		calculaFusoDestino(index) {
			if(this.form.trecho[index].decolagem_partida !== '' && this.form.trecho[index].designativo_destino !== ''){
				this._googleTimeZone(
					this.form.trecho[index].designativo_destino.latitude,
					this.form.trecho[index].designativo_destino.longitude,
					this.getDecolageGoogleTimeZone(this.form.trecho[index].decolagem_partida)).then((timezone) => {
					if(!window._.isNil(timezone.rawOffset)){
						this.form.trecho[index].fuso_destino = (timezone.dstOffset + timezone.rawOffset) / 3600
					}
					if(timezone.status === 'ZERO_RESULTS'){
						this.form.trecho[index].fuso_destino = 0
					}
				})
			}
		},
		validaTamanhoTrecho (index, campo, leng){
			this.$nextTick(() => {
				switch(campo) {
				case 'lat_partida':
					if(this.form.trecho[index].lat_partida.length !== leng){
						this.form.trecho[index].lat_partida = ''
						this.$forceUpdate()
					}
					break;
				case 'lng_partida':
					if(this.form.trecho[index].lng_partida.length !== leng){
						this.form.trecho[index].lng_partida = ''
					}
					break;
				case 'lat_destino':
					if(this.form.trecho[index].lat_destino.length !== leng){
						this.form.trecho[index].lat_destino = ''
					}
					break;
				case 'lng_destino':
					if(this.form.trecho[index].lng_destino.length !== leng){
						this.form.trecho[index].lng_destino = ''
					}
					break;
				}
			})
		},
		getDecolageGoogleTimeZone(horaDecolagem) {
			return window.moment(horaDecolagem, 'HH:mm').format('DD/MM/YYYY HH:mm')
		},
		calculaFusoOrigem(index, item, tipo){
			this.setaLatLong(index, item, tipo)
			if(this.form.trecho[index].decolagem_partida !== '' && this.form.trecho[index].designativo_partida !== ''){
				this._googleTimeZone(
					this.form.trecho[index].designativo_partida.latitude,
					this.form.trecho[index].designativo_partida.longitude,
					this.getDecolageGoogleTimeZone(this.form.trecho[index].decolagem_partida)).then((timezone) => {
					if(!window._.isNil(timezone.rawOffset)){
						this.form.trecho[index].fuso_partida = (timezone.dstOffset + timezone.rawOffset) / 3600
						this.calculaDataOrigemUTC(index)
					}
					if(timezone.status === 'ZERO_RESULTS'){
						this.form.trecho[index].fuso_partida = 0
						this.form.trecho[index].decolagem_utc_partida = this.form.trecho[index].decolagem_partida
					}
					if((timezone.dstOffset + timezone.rawOffset) === 0){
						this.form.trecho[index].fuso_partida = 0
						this.form.trecho[index].decolagem_utc_partida = this.form.trecho[index].decolagem_partida
					}
				})
			}
		},
		calculaDataOrigemUTC(index){
			if(this.form.trecho[index].fuso_partida === ''){
				this.calculaFusoOrigem(index, this.form.trecho[index], 'P')
			}else{
				let _data = window.moment(this.getDecolageGoogleTimeZone(this.form.trecho[index].decolagem_partida), window.$sessao.getDateFormat() + ' HH:mm')
				_data.add(this.form.trecho[index].fuso_partida * -1, 'hours')
				this.form.trecho[index].decolagem_utc_partida = _data.format('HH:mm')

			}
			this.$forceUpdate()
		},
		requests(tipo, local){
			return new Promise((resolve, reject) => {
				this._httpService(`localbusca/${tipo}/${escape(local)}`, 'GET', null, (response) => {
					resolve(response)
				})
			})
		},
		carregaEstados (item, index, tipo) {
			if (tipo === 'P') {
				if (!item.partidaEditando.editando.pais) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'P', 3);
					this.form.trecho[index].pais_partida = item.pais_partida
					this.form.trecho[index].id_pais_partida = item.pais_partida.codigo
				} else {
					item.partidaEditando.editando.pais = false
				}
				if (!!this.form.trecho[index].pais_partida.nome) {
					this.form.trecho[index].loadEstadoPartida = true
					this.requests('pais', this._removerAcentos(this.form.trecho[index].pais_partida.nome)).then((response) => {
						this.form.trecho[index].lista_estados_partida = response.filter((o) => o.province !== null)
						this.form.trecho[index].loadEstadoPartida = false
					})
				}
			}
			if (tipo === 'D') {
				if (!item.destinoEditando.editando.pais) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'D', 3);
					this.form.trecho[index].pais_destino = item.pais_destino
					this.form.trecho[index].id_pais_destino = item.pais_destino.codigo
				} else {
					item.destinoEditando.editando.pais = false
				}
				if (!!this.form.trecho[index].pais_destino.nome) {
					this.form.trecho[index].loadEstadoDestino = true
					this.requests('pais', this._removerAcentos(this.form.trecho[index].pais_destino.nome)).then((response) => {
						this.form.trecho[index].lista_estados_destino = response.filter((o) => o.province !== null)
						this.form.trecho[index].loadEstadoDestino = false
					})
				}
			}
		},
		carregaCidades (item, index, tipo) {
			if (tipo === 'P') {
				if (!item.partidaEditando.editando.estado) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'P', 2);
					this.form.trecho[index].estado_partida = item.estado_partida
					this.form.trecho[index].id_estado_partida = item.estado_partida.id
				} else {
					item.partidaEditando.editando.estado = false
				}
				if (!!this.form.trecho[index].estado_partida.province) {
					this.form.trecho[index].loadCidadePartida = true
					this.requests('province', this._removerAcentos(this.form.trecho[index].estado_partida.province)).then((response) => {
						this.form.trecho[index].lista_cidades_partida = response
						this.form.trecho[index].loadCidadePartida = false
					})
				}
			}
			if(tipo === 'D'){
				if (!item.destinoEditando.editando.estado) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'D', 2);
					this.form.trecho[index].estado_destino = item.estado_destino
					this.form.trecho[index].id_estado_destino = item.estado_destino.id
				} else {
					item.destinoEditando.editando.estado = false
				}
				if (!!this.form.trecho[index].estado_destino.province) {
					this.form.trecho[index].loadCidadeDestino = true
					this.requests('province', this._removerAcentos(this.form.trecho[index].estado_destino.province)).then((response) => {
						this.form.trecho[index].lista_cidades_destino = response
						this.form.trecho[index].loadCidadeDestino = false
					})
				}
			}
		},
		carregaAeroporto (item, index, tipo) {
			if (tipo === 'P') {
				if (!item.partidaEditando.editando.cidade &&
					this.form.trecho[index].id_cidade_partida !== item.cidade_partida.id) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'P', 1);
					this.form.trecho[index].cidade_partida = item.cidade_partida
					this.form.trecho[index].id_cidade_partida = item.cidade_partida.id
				} else {
					item.partidaEditando.editando.cidade = false
				}
				if (!!this.form.trecho[index].cidade_partida.cidade) {
					this.form.trecho[index].loadAeroportoPartida = true
					this.requests('cidade', this._removerAcentos(this.form.trecho[index].cidade_partida.cidade)).then((response) => {
						this.form.trecho[index].rotaer_partida = response.map((o) => {
							o._label = `${o.icao} - ${o.nome}`
							return o
						})
						this.form.trecho[index].loadAeroportoPartida = false
					})
				}
			}
			if (tipo === 'D') {
				if (!item.destinoEditando.editando.cidade &&
					this.form.trecho[index].id_cidade_destino !== item.cidade_destino.id) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(this.form.trecho[index], 'D', 1);
					this.form.trecho[index].cidade_destino = item.cidade_destino
					this.form.trecho[index].id_cidade_destino = item.cidade_destino.id
				} else {
					item.destinoEditando.editando.cidade = false
				}
				if (!!this.form.trecho[index].cidade_destino.cidade) {
					this.form.trecho[index].loadAeroportoDestino = true
					this.requests('cidade', this._removerAcentos(this.form.trecho[index].cidade_destino.cidade)).then((response) => {
						this.form.trecho[index].rotaer_destino = response.map((o) => {
							o._label = `${o.icao} - ${o.nome}`
							return o
						})
						this.form.trecho[index].loadAeroportoDestino = false
					})
				}
			}
		},
		verificaAeroporto(index, item) {
			if(this.form.trecho[index].designativo_partida !== ''){
				if(this.form.trecho[index].designativo_partida.id === this.form.trecho[index].designativo_destino.id){
					this.form.trecho[index].tem_pouso_previsto = true
				}else{
					this.form.trecho[index].tem_pouso_previsto = false
					this.form.trecho[index].pouso_previsto = ''
				}
			}
			this.$forceUpdate()
		},
	}
}
</script>
